/**
 * FIELD MAPPING: Vietnamese column names (Excel headers) <-> English camelCase keys
 *
 * Usage:
 *   import { VN_TO_EN, EN_TO_VN } from "./nhanhExcelFieldMapping";
 *   VN_TO_EN["Ngày Xuất Hàng"]  // => "deliveryDate"
 *   EN_TO_VN["deliveryDate"]     // => "Ngày Xuất Hàng"
 */

export const VN_TO_EN = {
  // Cột đặc biệt thêm vào để phân loại
  "orderType":                          "orderType",
  "batCode":                            "batCode",

  // 1-10
  "Ngày Xuất Hàng":                     "deliveryDate",
  "Loại chứng từ":                      "documentType",
  "Số chứng từ":                        "documentNumber",
  "Số Đơn Hàng":                        "orderNumber",
  "Ngày đơn hàng":                      "orderDate",
  "Ông bà":                             "salutation",
  "Địa chỉ":                            "address",
  "Ghi chú":                            "note",
  "ĐVTT":                               "currency",
  "Tỷ giá HT":                          "exchangeRate",

  // 11-20
  "Tên Khách Hàng":                     "customerName",
  "[Đối tượng công nợ] Tên KHNB":       "debtObjectName",
  "Mã KH":                              "customerCode",
  "Đối tượng ghi có":                   "creditObject",
  "[Đối tượng ghi có] Tên KHNB":        "creditObjectName",
  "[Đối tượng ghi có] Mã":              "creditObjectCode",
  "Chi tiết các khoản":                 "expenseDetails",
  "TK nợ":                              "debitAccount",
  "TK có":                              "creditAccount",
  "Tên Sản Phẩm":                       "productName",

  // 21-30
  "[Vật tư hàng hóa] Đvt":             "productUnit",
  "Mã Sản Phẩm":                        "productCode",
  "Đơn Vị Lẻ":                          "retailUnit",
  "Kho hàng":                           "warehouse",
  "Kho nhận":                           "receivingWarehouse",
  "Số Lot":                             "lotNumber",
  "Ngày Hết Hạn":                       "expiryDate",
  "Số lượng Lẻ":                        "retailQuantity",
  "Hesoquydoi":                         "conversionRatio",
  "Số lượng":                           "quantity",

  // 31-40
  "Đơn giá VND":                        "unitPriceVND",
  "Tiền Ngtệ":                          "foreignAmount",
  "Doanh Số":                           "salesAmount",
  "Thuế suất":                          "taxRate",
  "TK nợ VAT":                          "vatDebitAccount",
  "Tk có VAT":                          "vatCreditAccount",
  "Thành Tiền Thuế":                    "taxAmount",
  "% Chiết Khấu":                       "discountPercent",
  "TK Nợ CK":                           "discountDebitAccount",
  "TK Có CK":                           "discountCreditAccount",

  // 41-50
  "Tổng Tiền CK":                       "totalDiscount",
  "Đơn giá sau CK":                     "unitPriceAfterDiscount",
  "Thành tiền sau CK":                  "amountAfterDiscount",
  "Mẫu H.đơn":                          "invoiceTemplate",
  "Seri":                               "invoiceSeries",
  "Ngày hóa đơn":                       "invoiceDate",
  "Số hóa đơn":                         "invoiceNumber",
  "Nhóm VAT":                           "vatGroup",
  "MS thuế":                            "taxCode",
  "KH thuế":                            "taxCustomer",
  "ĐC thuế":                            "taxAddress",
  "Hình Thức Thanh Toán":               "paymentMethod",

  // 51-60
  "Bộ phận":                            "department",
  "GVTC":                               "costOfGoodsTC",
  "TK GVHB":                            "cogsAccount",
  "TK hạch toán":                       "accountingAccount",
  "Giá vốn":                            "costPrice",
  "TSCĐ":                               "fixedAsset",
  "[TSCĐ] Mã":                          "fixedAssetCode",
  "Tên Kênh KH":                        "salesChannelName",
  "Chương trình":                       "program",
  "[Chương trình] Mã":                  "programCode",

  // 61-70
  "Khoản mục Nội bộ":                   "internalItem",
  "[Khoản mục Nội bộ] Mã":              "internalItemCode",
  "Hop dong":                           "contract",
  "Số phiếu MTV":                       "mtvVoucherNumber",
  "Vùng":                               "region",
  "Đơn giá (đvt)":                      "unitPriceByUnit",
  "Dòng tiền":                          "cashFlow",
  "[Dòng tiền] Mã":                     "cashFlowCode",
  "Khoản mục Thuế":                     "taxItem",
  "Tên Nhân Viên":                      "staffName",

  // 71-80
  "Mảng kinh doanh":                    "businessSegment",
  "Mã NV (10 ký tự)":                   "staffCode",
  "Ngân hàng":                          "bank",
  "Kèm theo . . . . . .":              "attachments",
  "Số tiền 2 Ngtệ":                     "secondForeignAmount",
  "Kênh KH":                            "customerChannel",
  "Mức CK T.Toán":                      "paymentDiscountLevel",
  "Phân xưởng":                         "workshop",
  "[Phân xưởng] Mã":                    "workshopCode",
  "ĐTCP_TP":                            "investmentProject",

  // 81-88
  "[ĐTCP_TP] Mã":                       "investmentProjectCode",
  "Số lô SP":                           "productLotNumber",
  "SLSX":                               "productionQuantity",
  "Mã Kho":                             "warehouseCode",
  "[Kho nhận] Mã":                      "receivingWarehouseCode",
  "[Mảng kinh doanh] Mã":               "businessSegmentCode",
  "Ngày hạn t.t":                       "paymentDueDate",
};

// Reverse mapping: English => Vietnamese
export const EN_TO_VN = Object.fromEntries(
  Object.entries(VN_TO_EN).map(([vn, en]) => [en, vn])
);
